module.exports = __webpack_public_path__ + "img/icon-close2.b19ec54a.svg";